<template>
  <eg-form-group required>
    <div class="flex-gap-1 d-flex flex-wrap">
      <ToggleButton
        v-for="language in filteredLanguages"
        :key="language.value"
        :label="language.text"
        :value="language.value"
        :pressed="value === language.value"
        variant="info"
        horizontal
        @click="handleChange(language.value)"
      >
        <img
          :src="require(`@/assets/icons/flags/${language.icon}.svg`)"
          :alt="language.icon"
          class="language-icon"
        />
      </ToggleButton>
    </div>
  </eg-form-group>
</template>

<script>
import EgFormGroup from "../../global/eg_form_group.vue";
import ToggleButton from "@/components/global/eg_toggle_button.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    EgFormGroup,
    ToggleButton,
  },

  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabledLanguages: {
      type: Array, // Array<Number>
      required: false,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters("languages", ["getLanguagesList", "getLastUsedLanguageId"]),
    filteredLanguages() {
      return this.filterLanguages(this.getLanguagesList);
    },
  },

  created() {
    // input language selector typically has not disabled languages
    if (!this.value && !this.disabledLanguages.length) {
      this.setLastUsedLanguageActive();
    }
  },

  methods: {
    handleChange(languageId) {
      this.$emit("input", languageId);
      this.$store.commit("languages/SET_LAST_USED_LANGUAGE_ID", languageId);
    },

    filterLanguages(languages) {
      return languages.filter(
        (language) => !this.disabledLanguages.includes(language.value)
      );
    },

    setLastUsedLanguageActive() {
      this.$emit("input", this.getLastUsedLanguageId);
    },
  },
};
</script>
